/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { settingClientControllerGetSettingsV1 } from '../fn/setting-client/setting-client-controller-get-settings-v-1';
import { SettingClientControllerGetSettingsV1$Params } from '../fn/setting-client/setting-client-controller-get-settings-v-1';
import { settingClientControllerSetSettingsV1 } from '../fn/setting-client/setting-client-controller-set-settings-v-1';
import { SettingClientControllerSetSettingsV1$Params } from '../fn/setting-client/setting-client-controller-set-settings-v-1';
import { SettingDto } from '../models/setting-dto';

@Injectable({ providedIn: 'root' })
export class SettingClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settingClientControllerGetSettingsV1()` */
  static readonly SettingClientControllerGetSettingsV1Path = '/api/v1/settings/client';

  /**
   * 설정값을 조회.
   *
   * 설정값을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingClientControllerGetSettingsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingClientControllerGetSettingsV1$Response(params?: SettingClientControllerGetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
    const obs = settingClientControllerGetSettingsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 설정값을 조회.
   *
   * 설정값을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingClientControllerGetSettingsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingClientControllerGetSettingsV1(params?: SettingClientControllerGetSettingsV1$Params, context?: HttpContext): Observable<Array<SettingDto>> {
    const resp = this.settingClientControllerGetSettingsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SettingDto>>): Array<SettingDto> => r.body)
    );
  }

  /** Path part for operation `settingClientControllerSetSettingsV1()` */
  static readonly SettingClientControllerSetSettingsV1Path = '/api/v1/settings/client';

  /**
   * 설정값을 변경.
   *
   * 설정값을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingClientControllerSetSettingsV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingClientControllerSetSettingsV1$Response(params: SettingClientControllerSetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = settingClientControllerSetSettingsV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 설정값을 변경.
   *
   * 설정값을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingClientControllerSetSettingsV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingClientControllerSetSettingsV1(params: SettingClientControllerSetSettingsV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.settingClientControllerSetSettingsV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
